<div #volumeDialogContent class="volume-dialog-content" mat-dialog-content>
  <mwo-button (click)="handleVolumeChangeButtonClicked(true)" [active]="false" [disable]="disabled || volume <= 0"
              [icon]="'remove'"
              [noActiveColor]="true"
              class="volume-change-button" id="down"></mwo-button>
  <div class="vertical volume-window popup-container" id="volume">
    <input
      [(ngModel)]="volume" [disabled]="disabled" max="100" min="0"
      style="opacity: 0;"
      type="range"/>
    <img *ngIf="false" [src]="getVolumeIcon()" alt="volume-icon" class="volume-icon"/>
  </div>
  <mwo-button (click)="handleVolumeChangeButtonClicked(false)" [active]="false" [disable]="disabled || volume >= 100"
              [icon]="'add'" [noActiveColor]="true"
              class="volume-change-button" id="up"></mwo-button>
</div>
